import VideoIndicationIcon from "../../../uikit/VideoIndicationIcon";
import { useEnrichmentCardContext } from "../../../pages/DataPage/CardsView/DataList/EnrichmentCard/EnrichmentCardProvider";

export const FrameIndication = ({ timestamp }: { timestamp: number }) => {
  const { isSingleItem } = useEnrichmentCardContext();
  return (
    <>
      <VideoIndicationIcon small={!isSingleItem} />
    </>
  );
};
